<template>
  <div>
    <div class="condition-section">
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">邮箱：</div>
          <Input
            class="height45"
            v-model="email"
            placeholder="请输入搜索的名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button
            class="btn-height45"
            @click="onSearchCancel"
            style="margin-right: 20px"
            >重置</Button
          >
          <Button
            class="btn-height45"
            type="primary"
            @click="addEmailModalVisibility = true"
            >添加邮箱认证</Button
          >
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total">搜索结果（{{ total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="status" slot-scope="{ row }">
          <div>
            {{ row.status | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div v-if="row.status != 1" style="display:flex">
            <Button style="margin-right: 10px" @click="onReloadItem(row)"
              >重新发送认证邮件</Button
            >
            <Button @click="onDeleteItem(row)">删除</Button>
          </div>
          <div v-else>--</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
    <addEmailModal
      :show.sync="addEmailModalVisibility"
      @submit-success="onSuccess"
    ></addEmailModal>
  </div>
</template>

<script>
import {
  certifiedEmailList,
  certifiedEmailDelete,
  certifiedEmailSendEmail,
} from "api/customer.js";
import addEmailModal from "components/account/addEmailModal.vue";

export default {
  name: "myEmail",
  components: {
    addEmailModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "认证中";
          break;
        case 1:
          title = "认证成功";
          break;
        case 2:
          title = "认证失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      email: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "序号",
          align: "center",
          type: "index",
        },
        {
          title: "邮箱",
          align: "center",
          key: "email",
        },
        {
          title: "提交时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "状态",
          align: "center",
          slot: "status",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
      addEmailModalVisibility: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          email: this.email,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await certifiedEmailList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.email = "";
      this.onPageChange(1);
    },
    // 添加认证成功
    async onSuccess(callback) {
      await this.req_getList();
      callback(true);
    },
    // 删除确认
    onDeleteItem(val) {
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除此邮箱认证吗？</p>",
        onOk: async () => {
          const res = await certifiedEmailDelete(val.id);
          if (res.code === 200 && res.result) {
            this.$Message.success("删除成功！");
            this.req_getList();
          }
        },
      });
    },
    // 重新发送
    onReloadItem(val) {
      this.$Modal.confirm({
        title: "重发确认",
        content: "<p>确定重新发送认证邮件到</p><p>" + val.email + "？</p>",
        onOk: async () => {
          const res = await certifiedEmailSendEmail({ email: val.email });
          if (res.code === 200 && res.result) {
            this.$Message.success("操作成功！");
            this.req_getList();
          }
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.condition-section {
  margin: 15px;
  background-color: #fff;
  padding: 20px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #315491;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 60px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>
<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
